import * as SimpleNewsList from './SimpleNewsList'
import * as NewsList from './NewsList'
import * as PenaltyList from './PenaltyList'
import * as PenaltyDetails from './PenaltyDetails'
import * as CompanyNewsList from './CompanyNewsList'

export default [
    {
        id: 'simple-news-list',
        name: '简单资讯列表',
        component: SimpleNewsList.default,
        regions: SimpleNewsList.regions,
        preview: SimpleNewsList.preview,
        thumbnail: SimpleNewsList.thumbnail,
        getFields: SimpleNewsList.getFields,
        validateConfig: SimpleNewsList.validateConfig
    },
    {
        id: 'news-list',
        name: '带封面图资讯列表',
        component: NewsList.default,
        regions: NewsList.regions,
        preview: NewsList.preview,
        thumbnail: NewsList.thumbnail,
        getFields: NewsList.getFields,
        validateConfig: NewsList.validateConfig
    },
    {
        id: 'penalty-list',
        name: '处罚信息列表',
        component: PenaltyList.default,
        regions: PenaltyList.regions,
        preview: PenaltyList.preview,
        thumbnail: PenaltyList.thumbnail,
        getFields: PenaltyList.getFields,
        validateConfig: PenaltyList.validateConfig
    },
    {
        id: 'penalty-details',
        name: '处罚信息细览',
        component: PenaltyDetails.default,
        regions: PenaltyDetails.regions,
        preview: PenaltyDetails.preview,
        thumbnail: PenaltyDetails.thumbnail,
        getFields: PenaltyDetails.getFields,
        validateConfig: PenaltyDetails.validateConfig
    },
    {
        id: 'company-news-list',
        name: '公司资讯列表',
        component: CompanyNewsList.default,
        regions: CompanyNewsList.regions,
        preview: CompanyNewsList.preview,
        thumbnail: CompanyNewsList.thumbnail,
        getFields: CompanyNewsList.getFields,
        validateConfig: CompanyNewsList.validateConfig
    },
]
